import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { IFotoramaOptions } from '../../../typings/fotorama';
import { RoundButton } from '../RoundButton';
import * as styles from './GalleryView.css';
import { IGalleryTab } from '../../types/gallery';
import {
  IconActionChevronLeft16,
  IconActionChevronRight16,
  IconActionFullscreen16,
} from '@cian/ui-kit-design-tokens/icons';
import { InfoTabs } from './InfoTabs';

export interface IGalleryViewProps {
  total: number;
  options: IFotoramaOptions;
  isHidden?: boolean;
  tabs?: IGalleryTab[];
  onTabClick?(tab: IGalleryTab): void;
  onMount(gallery: HTMLDivElement): void;
  onLeftArrowClick(): void;
  onRightArrowClick(): void;
  onFullscreenButtonClick(): void;
}

export class GalleryView extends React.Component<IGalleryViewProps> {
  public galleryRef = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    if (this.galleryRef.current) {
      this.props.onMount(this.galleryRef.current);
    }
  }

  public render() {
    const { total, options, isHidden, tabs, onTabClick, onLeftArrowClick, onRightArrowClick, onFullscreenButtonClick } =
      this.props;

    const { thumbheight, thumbwidth, fit, swipe, nav, maxHeight, ratio } = options;

    return (
      <div
        {...mergeStyles(
          styles['container'],
          styles['project_card_gallery_container'],
          (!nav || nav === 'false') && styles['container--no-thumbs'],
          total < 2 && styles['container--no-controls'],
          isHidden && styles['container--hidden'],
        )}
        data-name="GalleryView"
      >
        <div
          className={styles['fotorama']}
          data-width="100%"
          data-ratio={ratio}
          data-minheight="214"
          data-maxheight={maxHeight}
          data-nav={nav}
          data-fit={fit}
          data-keyboard="true"
          data-loop="true"
          data-arrows="false"
          data-swipe={swipe}
          data-thumbmargin="8"
          data-thumbborderwidth="1"
          data-auto="false"
          data-click="false"
          data-allowfullscreen="true"
          data-thumbwidth={thumbwidth}
          data-thumbheight={thumbheight}
          ref={this.galleryRef}
        />

        {tabs && <InfoTabs offsetBottom={total > 1 ? 100 : 24} tabs={tabs} onTabClick={onTabClick} />}

        <RoundButton buttonStyles={styles['left_arrow']} onClick={onLeftArrowClick}>
          <IconActionChevronLeft16 color="icon-on-bright-default" />
        </RoundButton>

        <RoundButton buttonStyles={styles['right_arrow']} onClick={onRightArrowClick}>
          <IconActionChevronRight16 color="icon-on-bright-default" />
        </RoundButton>

        <RoundButton buttonStyles={styles['fullscreen_toggle']} onClick={onFullscreenButtonClick}>
          <IconActionFullscreen16 color="icon-on-bright-default" />
        </RoundButton>
      </div>
    );
  }
}
